import React from 'react';

const Card = ({ 
  children, 
  title, 
  subtitle, 
  icon, 
  actions, 
  variant = 'default',
  className = '',
  onClick,
  loading = false,
  error = false
}) => {
  const cardClasses = [
    'card',
    `card-${variant}`,
    className,
    onClick ? 'card-clickable' : '',
    loading ? 'card-loading' : '',
    error ? 'card-error' : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClasses} onClick={onClick}>
      {(title || icon || actions) && (
        <div className="card-header">
          <div className="card-header-content">
            {icon && (
              <div className="card-icon">
                {icon}
              </div>
            )}
            <div className="card-title-section">
              {title && (
                <h3 className="card-title">
                  {title}
                </h3>
              )}
              {subtitle && (
                <p className="card-subtitle">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          
          {actions && (
            <div className="card-actions">
              {actions}
            </div>
          )}
        </div>
      )}
      
      <div className="card-content">
        {loading ? (
          <div className="card-loading-content">
            <div className="loading-spinner"></div>
            <span>Carregando...</span>
          </div>
        ) : error ? (
          <div className="card-error-content">
            <div className="error-icon">⚠</div>
            <span>{error}</span>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default Card; 